<tt-page>
    <tt-page-heading>{{ heading }}</tt-page-heading>
    <tt-products-config style="max-width: 90rem" [params]="params" (getLoaded)="setHeading($event)" (submit)="onSubmit($event)"></tt-products-config>
</tt-page>
